export default __webpack_public_path__ + "static/Polymer-7cdfacc391a52c459f51d3b3f8ae7f44.png";